import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const LegalPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#131313',
      color: 'white',
      padding: '1rem'
    }}>
      {/* Header */}
      <header style={{
        display: 'flex',
        alignItems: 'center',
        padding: '1rem',
        borderBottom: '1px solid #262626',
        marginBottom: '2rem'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#8E8E8E',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            marginRight: '1rem'
          }}
        >
          <ChevronLeft size={20} />
        </button>
        <h1 style={{ fontSize: '1.5rem', fontWeight: '600' }}>Legal Information</h1>
      </header>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        {/* Privacy Policy Section */}
        <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ color: 'white', marginBottom: '1rem' }}>Privacy Policy</h2>
            <p style={{ color: 'lightgrey', fontSize: '0.875rem' }}>
              Effective Date: 03/01/25<br/>
              Last Updated: 03/01/25<br/><br/>
              This Privacy Policy explains how 4FRNT Education LLC ("we," "our," or "us") collects, uses, and discloses information about you when you use our web application Speil (the "App") available at https://speil-tdy.web.app/. By accessing or using our App, you agree to the collection and use of information in accordance with this Privacy Policy.<br/><br/>
              <strong>1. Information We Collect</strong><br/>
              a. Personal Information<br/>
              Account Registration: When you register for an account, we may collect your name, email address, and any other information you choose to provide.<br/>
              Support Communications: If you contact our support team via email (rodrigo@onda-st.com), we will keep a record of that correspondence.<br/><br/>
              b. User-Generated Content<br/>
              Images and Diary Entries: Speil allows you to upload images and create diary entries that are structured similarly to a Netflix show. Any content you upload is subject to this policy.<br/>
              Friend Connections: You may add up to 10 friends within the App. Information associated with these connections, such as usernames or profiles, may be stored and shared within your network as part of the App's features.<br/><br/>
              c. Usage Data<br/>
              We automatically collect usage data that may include log data, device information, browser type, access times, and interactions with our App.<br/><br/>
              <strong>2. How We Use Your Information</strong><br/>
              We use the information we collect for purposes including providing and maintaining our service, account management, communication, and personalization.<br/><br/>
              <strong>3. Sharing Your Information</strong><br/>
              Within the App: Your diary entries, images, and friend connection data may be visible to others within your network.<br/>
              Third-Party Service Providers: We may share your information with trusted service providers who help operate the App.<br/><br/>
              <strong>4. Data Security</strong><br/>
              We take reasonable measures to protect your information, though no transmission method over the Internet is completely secure.<br/><br/>
              <strong>5. Data Breach Notification</strong><br/>
              In the event of a data breach, we will notify you in accordance with the Florida Information Protection Act (FIPA) and other applicable laws.<br/><br/>
              <strong>6. Data Retention and Deletion</strong><br/>
              Retention: We retain your information only as long as necessary to fulfill the purposes of this Privacy Policy.<br/>
              Deletion: You may request deletion of your account and associated data by contacting us at rodrigo@onda-st.com.<br/><br/>
              <strong>7. Cookies and Tracking Technologies</strong><br/>
              We may use cookies and similar technologies to track activity on our App. Refusing cookies may affect functionality.<br/><br/>
              <strong>8. Changes to This Privacy Policy</strong><br/>
              We may update this Privacy Policy periodically. Your continued use of the App will constitute acceptance of the updated policy.<br/><br/>
              <strong>9. Contact Us</strong><br/>
              Email: rodrigo@onda-st.com
            </p>

            <h2 style={{ color: 'white', margin: '1.5rem 0 1rem' }}>Terms of Service</h2>
            <p style={{ color: 'lightgrey', fontSize: '0.875rem' }}>
              Effective Date: 03/01/25<br/><br/>
              Please read these Terms of Service ("Terms") carefully before using the Speil web application (the "Service") operated by 4FRNT Education LLC. By accessing or using the Service, you agree to be bound by these Terms.<br/><br/>
              <strong>1. Acceptance of Terms</strong><br/>
              By using the Service, you affirm that you are over 16 and agree to these Terms. If you do not agree, please do not use the Service.<br/><br/>
              <strong>2. Description of the Service</strong><br/>
              Speil allows users to upload images, create diary entries in a show-like format, and connect with up to 10 friends.<br/><br/>
              <strong>3. Account Registration</strong><br/>
              You must create an account to access the Service and provide accurate, current information.<br/><br/>
              <strong>4. User Content</strong><br/>
              You retain ownership of your content, but grant us a license to use it for operating and improving the Service.<br/><br/>
              <strong>5. Friend Connections</strong><br/>
              Users may add up to 10 friends. Certain profile information may be visible to added friends per our Privacy Policy.<br/><br/>
              <strong>6. Prohibited Conduct</strong><br/>
              You agree not to use the Service for any illegal, harmful, or unauthorized purposes.<br/><br/>
              <strong>7. Intellectual Property</strong><br/>
              All intellectual property rights in the Service are owned by or licensed to 4FRNT Education LLC.<br/><br/>
              <strong>8. Termination</strong><br/>
              We reserve the right to suspend or terminate your account if you violate these Terms.<br/><br/>
              <strong>9. Disclaimers and Limitation of Liability</strong><br/>
              The Service is provided "as is" without warranties, and 4FRNT Education LLC is not liable for any indirect damages.<br/><br/>
              <strong>10. Governing Law</strong><br/>
              These Terms are governed by the laws of the State of Florida.<br/><br/>
              <strong>11. Changes to Terms</strong><br/>
              We reserve the right to modify these Terms at any time. Continued use of the Service constitutes acceptance of any changes.<br/><br/>
              <strong>12. Contact Us</strong><br/>
              Email: rodrigo@onda-st.com
            </p>
        </section>
      </div>
    </div>
  );
};

export default LegalPage; 